@if (orderDetails$ | async; as orderDetails) {
  <!-- submitted by -->
  @if (orderDetails.orderUserDetails; as orderCreatorUser) {
    @if (orderCreatorUser.name) {
      <div class="submitted-by">
        <div class="column-title">
          {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.CREATED_BY' | translate }}
        </div>
        <span class="order-creator-name">{{ orderCreatorUser.name }}</span>
        @if (orderCreatorUser.badgeColor && orderCreatorUser.badgeTranslationKey) {
          <glxy-badge color="{{ orderCreatorUser.badgeColor }}">
            {{ orderCreatorUser.badgeTranslationKey | translate }}
          </glxy-badge>
        }
      </div>
    }
  }
  <!-- salesperson -->
  @if (!!orderDetails.salesperson) {
    <div class="salesperson">
      <div class="column-title">
        {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.SALESPERSON' | translate }}
      </div>
      <div>{{ orderDetails.salesperson?.firstName || '' }} {{ orderDetails.salesperson?.lastName || '' }}</div>
    </div>
  }
  <!-- company -->
  @if (!!orderDetails.companyLink) {
    <orders-company-name [business]="orderDetails.business" [url]="orderDetails.companyLink" />
  }
  <!-- address -->
  <orders-company-address [business]="orderDetails.business" />
  <!-- contract -->
  @if (orderDetails.contractDetails; as orderContractDetails) {
    <div>
      @if (orderDetails.canEditContractDetails) {
        <div class="contract-details editable">
          <orders-contract-start
            [minDate]="orderContractDetails.minimumContractStartDate"
            [maxDate]="orderContractDetails.maximumContractStartDate"
            [contractStartDate]="orderContractDetails.contractStartDate"
            (contractStartDateChange)="handleContractStartDateChange($event)"
            [viewOnly]="orderDetails.loading"
          >
          </orders-contract-start>
          <orders-contract-duration
            [contractDuration]="orderContractDetails.contractDuration"
            [hideHintText]="false"
            (contractDurationChange)="handleContractDurationChange($event)"
            [viewOnly]="orderDetails.loading"
          >
          </orders-contract-duration>
        </div>
      } @else {
        <div class="contract-details readonly">
          <div>
            <div class="column-title">
              {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.CONTRACT_START' | translate }}
            </div>
            <div>
              {{ orderContractDetails.contractStartDate | date }}
            </div>
          </div>
          @if (orderContractDetails.contractDuration | formatDuration; as duration) {
            <div [class]="'contract-duration'">
              <div class="column-title">
                {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.CONTRACT_DURATION' | translate }}
              </div>
              <div>{{ duration.value }} {{ duration.period }}</div>
              <span class="contract-duration-hint">{{ 'SALES_CONTRACT_DURATION.HINT' | translate }}</span>
            </div>
          }
        </div>
      }
    </div>
  }
  <!-- customer agreements -->
  @if (orderDetails.customerAgreementData; as agreementData) {
    @if (agreementData?.agreements?.length > 0) {
      <div class="dynamic-item-container dynamic-list-item customer-agreements">
        <div class="column-title">
          {{ 'LIB_ORDERS.COMMON.ORDER_DETAILS.CUSTOMER_AGREEMENTS' | translate }}
        </div>
        <div class="order-details__list-item__value">
          @if (agreementData.lastAcceptedName && agreementData.lastAcceptedDate) {
            <div>
              {{
                'LIB_ORDERS.COMMON.ORDER_DETAILS.ACCEPTED_ON'
                  | translate: { date: agreementData.lastAcceptedDate, name: agreementData.lastAcceptedName }
              }}
            </div>
          }
          @for (agreement of agreementData.agreements; track agreement; let isLast = $last) {
            <div class="agreements">
              <div class="agreement-container">
                <div class="checkbox-container">
                  @if (agreement?.agreed) {
                    <mat-icon class="agreement-accepted">check_circle_outline</mat-icon>
                  } @else {
                    <mat-icon class="agreement-not-accepted">highlight_off</mat-icon>
                  }
                </div>
                <div class="agreement-content">
                  <div>
                    @if (agreement?.term) {
                      <span [innerHTML]="agreement.term"></span>
                    }
                  </div>
                  @if (agreement?.name) {
                    <div class="agreement-submitted-by">
                      <b>Submitted By:</b>
                      {{ agreement.name }}
                    </div>
                  }
                </div>
              </div>
              @if (!isLast) {
                <div class="agreements-divider">
                  <mat-divider></mat-divider>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  }
}
